module.exports = __webpack_public_path__ + "img/aboutUs.204eefaa.png";